export default "__VITE_ASSET__BcTeFvrY__"